import React, { useRef, useState } from "react";
import { Overlay, Popover } from "react-bootstrap";
import styles from "./MessageCellRenderer.module.css";

const MessageCellRenderer: React.FC<any> = (props) => {
  const message = props.value;
  const targetRef = useRef<HTMLDivElement | null>(null);
  const [show, setShow] = useState(false);

  if (!message) return <span></span>;

  return (
    <>
      <div
        ref={targetRef}
        className={styles.messageCell}
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
      >
        {message}
      </div>

      <Overlay
        target={targetRef.current}
        show={show}
        placement="bottom"
      >
        {(overlayProps) => (
          <Popover {...overlayProps} className={styles.messagePopover}>
            <Popover.Body>
              {message.split("\n").map((line: string, index: number) => (
                <div key={index}>{line}</div>
              ))}
            </Popover.Body>
          </Popover>
        )}
      </Overlay>
    </>
  );
};

export default MessageCellRenderer;
